import { FormGroup, Glyphicon } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import ErrorMessage from 'components/forms/_errorMessage/ErrorMessage';
import { getPresetNavigationRows } from './NavigationSettings.constants';
import {
  createNavigationRow,
  MAX_CUSTOM_NAVIGATION_ITEMS,
  NavigationSettingsFormValues,
} from './NavigationSettings.schema';
import {
  NavigationFooterStyled,
  NavigationRowsStyled,
} from './NavigationSettings.styles';
import NavigationPresetRow from './NavigationPresetRow';
import NavigationRow from './NavigationRow';

const NavigationRows = ({ websiteUrl }: { websiteUrl?: string | null }) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<NavigationSettingsFormValues>();
  const {
    fields: rows,
    append,
    remove,
  } = useFieldArray({ control, name: 'navigation' });

  const presets = getPresetNavigationRows(t, websiteUrl);

  const handleAdd = () => append(createNavigationRow(), { shouldFocus: false });

  return (
    <NavigationRowsStyled>
      {presets.map((preset, index) => (
        <NavigationPresetRow
          key={preset.key}
          row={preset}
          showTooltip={index === 0}
        />
      ))}

      {rows.map((row, index) => (
        <NavigationRow
          index={index}
          key={row.key}
          onDelete={() => remove(index)}
        />
      ))}

      {errors.navigation?.message && (
        <FormGroup validationState="error">
          <ErrorMessage error={errors.navigation.message} />
        </FormGroup>
      )}

      {rows.length < MAX_CUSTOM_NAVIGATION_ITEMS && (
        <NavigationFooterStyled>
          <Button
            data-testid="add-navigation-button"
            leftIcon={<Glyphicon glyph="plus" />}
            onClick={handleAdd}
          >
            {t('pageDirectBookingEngine.navigationSettings.addNavigation')}
          </Button>
        </NavigationFooterStyled>
      )}
    </NavigationRowsStyled>
  );
};

export default NavigationRows;
